<template>
  <el-dialog
    class="common-dialog"
    :title="dialogOptions.title"
    :visible.sync="visible"
    center
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    @close="dialogClose"
    :show-close="showClose"
    :append-to-body="appendToBody"
  >
    <span v-html="dialogOptions.tip"></span>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="clickCancel" size="small" v-if="showCancel">{{ dialogOptions.cancelText || '取 消' }}</el-button>
      <el-button type="primary" @click="clickConfirm" size="small">{{ dialogOptions.confirmText || '确 定' }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'TipDialog',
  data() {
    return {
      visible: false
    }
  },
  props: {
    dialogOptions: {
      type: Object,
      default: function() {
        return {
          type: '', // space 空间购买，member 会员购买, delete 删除
          title: '提示',
          tip: '',
          cancelText: '取 消',
          confirmText: '确 定'
        }
      }
    },
    showClose: { type: Boolean, default: true },
    appendToBody: { type: Boolean, default: false },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    dialogClose() {
      if (this.showClose) {
        this.$emit('clickCancel')
      }
    },
    clickCancel() {
      this.visible = false
      this.$emit('clickCancel')
    },
    clickConfirm() {
      if (!this.showCancel) {
        this.visible = false
      } else {
        this.visible = false
        this.$emit('clickConfirm')

        if (this.dialogOptions.type == 'member' || this.dialogOptions.type == 'space') {
          this.$router.push({ path: '/openVIP' })
        }
      }
    }
  }
}
</script>
